/* Vellyka, 24-10-2026: Ximena paga el envío en las seis regiones habilitadas.
 * EasySell muestra '?' hasta elegir región, aunque todas las tarifas son gratis.
 * Solo aclaramos ese texto inicial: nunca sustituimos un monto ni una tarifa
 * calculada. Retirar este ajuste si cambia la política de envío. El constructor
 * nativo de EasySell no cargó al aplicar esta corrección.
 */
(() => {
  const coveredRegions = new Set(['CL_BI', 'CL_ML', 'CL_NB', 'CL_LI', 'CL_RM', 'CL_VS']);
  function clarifyShipping() {
    document.querySelectorAll('#easysell .es-form').forEach((form) => {
      const province = form.querySelector('select[name="province"]');
      if (!province || province.value) return;
      const regions = [...province.options].filter((option) => option.value && !option.disabled);
      // Si se amplía la cobertura, el formulario vuelve a su texto nativo.
      if (regions.length !== coveredRegions.size || regions.some((option) => !coveredRegions.has(option.value))) return;
      form.querySelectorAll('.es-shipping-row .label-value > span').forEach((value) => {
        if (value.textContent.trim() === '?') value.textContent = 'Gratis';
      });
    });
  }
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; clarifyShipping(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  clarifyShipping();
})();
